import { render, staticRenderFns } from "./account-upload.vue?vue&type=template&id=b2e96d00"
import script from "./account-upload.vue?vue&type=script&lang=js"
export * from "./account-upload.vue?vue&type=script&lang=js"
import style0 from "./account-upload.vue?vue&type=style&index=0&id=b2e96d00&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports